import { render, staticRenderFns } from "./RankingTransformer101.vue?vue&type=template&id=4f6452ee&scoped=true&"
import script from "./RankingTransformer101.vue?vue&type=script&lang=js&"
export * from "./RankingTransformer101.vue?vue&type=script&lang=js&"
import style0 from "./RankingTransformer101.vue?vue&type=style&index=0&id=4f6452ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6452ee",
  null
  
)

export default component.exports